import React, { useEffect, useState } from 'react'
import '../myProjects.css'
import { MDBAccordion, MDBAccordionItem, MDBBtn } from 'mdb-react-ui-kit';
import { Navigate, useNavigate } from 'react-router-dom';

function postedProjects() {
    const navigate = useNavigate()
    const [token, setToken] = useState(null)
    const [projects, setProjects] = useState(null)
    const [tokenLoaded, setTokenLoaded] = useState(false)
    const [currentUserId, setCurrentUserId] = useState(undefined)
    const [currentUserEmail, setCurrentUserEmail] = useState(undefined)
    const [displayProjects, setDisplayProjects] = useState(false)
    const [admin, setAdmin] = useState(null)


    useEffect(() => {
        if (localStorage.getItem("user")) {

            //setCurrentUserEmail(localStorage.getItem("user"))
            localStorage.getItem("token")[3] == "Y" ? setAdmin(true) : setAdmin(false)
            setToken(localStorage.getItem("token").slice(0, 3) + localStorage.getItem("token").slice(4))
            setTokenLoaded(true)
        }
        else {//TODO if localstorage user not found redirect to "/"
            console.log(`user local storage not found`)
        }
    }, [])
    
    useEffect(() => {
        window.scrollTo(0, 0)
        
    },[])

    useEffect(() => {
        console.log(token)
        if (tokenLoaded) {
            fetch(Url+'project/readMyProjects', {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "authorization": token
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log("posted: ", data.allMyProjects)
                    setProjects(data.allMyProjects)
                    setDisplayProjects(true)
                })
                .catch(err => console.log(err))
        }

    }, [tokenLoaded])

    return (
        <>
            <div className=''>

                <div className=''>

                    <MDBAccordion initialActive={0} alwaysOpen>
                        {
                            displayProjects ? projects.map((projects, key) => {
                                return (
                                    <MDBAccordionItem className='' collapseId={key + 1}
                                        headerTitle={projects.projectName}
                                        key={projects._id + "placeholder"}>

                                        <div className='row'>
                                            <div className='col-md-3' >
                                                <img className='custom-img' src={projects.imageOfTheProject} alt="" />

                                                {projects.originalCreatorPhoto &&
                                                    <>
                                                        <img id="" className='custom-img' src={projects.originalCreatorPhoto} alt="" />
                                                    </>
                                                }
                                                {projects.pictureOfMaterial &&
                                                    <>
                                                        <img id="" className='custom-img' src={projects.pictureOfMaterial} alt="" />
                                                    </>
                                                }
                                            </div>
                                            <p className='col-md-6' style={{ textAlign: "center" }}>
                                                <strong>Project Name: </strong>
                                                {projects.projectName}
                                                <hr />
                                                <strong>Description: </strong>
                                                {projects.projectDescription}
                                                <hr />
                                                <strong>Kind Of Project: </strong>
                                                {projects.projectType}
                                                <hr />

                                                <strong>Type of Work: </strong>
                                                {projects.typeOfWork}
                                                <hr />
                                                <strong>Materials: </strong>
                                                {projects.material}
                                                <hr />

                                                <p ><strong>Location: </strong>{

                                                    projects.locationCountry && projects.locationCountry == "us"
                                                        ? `United States ${projects.locationState != "" ? "/ " + projects.locationState : ""}`
                                                        : projects.locationCountry
                                                }</p>

                                                <MDBBtn onClick={e => navigate(`/updateProject/${projects._id}`)}>Edit</MDBBtn>
                                            </p>

                                            <h6 className='col-md-1 status'>{projects.status.toUpperCase()}</h6>
                                        </div>
                                    </MDBAccordionItem>
                                )
                            }) : <h1>here false</h1>
                        }

                    </MDBAccordion>
                </div>
            </div>
        </>
    )
}

export default postedProjects
